export const EXCHANGER_STATES ={
    "-1": '--',
    0: '--',
    1: 'Incompleto',
    2: 'Verificar',
    3: 'Completo'
}